var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8865 5.61377H18.991V1.94674C17.9724 1.83467 16.9483 1.78029 15.9236 1.78386C12.8879 1.78386 10.8094 3.69377 10.8094 7.20368V10.4325H7.45947V14.532H10.8094V24.8469H14.916V14.5334H18.1305L18.6407 10.4325H14.9146V7.60728C14.9146 6.42241 15.2346 5.61232 16.8851 5.61232L16.8865 5.61377Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.36620dbd7e7491cefdec731951210aad.svg";
export { ForwardRef as ReactComponent };